import {
  Component, inject, signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AdminService } from '../admin/services/admin.service';
import { MaterialModule } from '../shared/material.module';
import { firstValueFrom, take } from 'rxjs';

@Component({
    selector: 'app-domain',
    templateUrl: './domain.component.html',
    styleUrls: ['./domain.component.scss'],
    imports: [ReactiveFormsModule, MaterialModule]
})
export class DomainComponent {
  public loading = signal(false);

  domainControl = new FormControl('', [Validators.required]);

  private readonly companyService = inject(AdminService);

  loadDomain(): void {
    this.loading.set(true);
    const domain = this.domainControl.value.replace(/(^\w+:|^)\/\//g, '');
    console.log('Domain:', domain);
    this.companyService.connect(domain).pipe(take(1)).subscribe(() => {
      console.log('Domain connected');
      this.loading.set(false);
      localStorage.setItem('domain', domain);
      window.location.reload();
    }, (error) => {
      console.error('Error connecting domain',error);
      this.loading.set(false);
    });
  }
}
